import axios from "axios";
import { authHeader } from "./accessToken";

const buildQueryParams = (params) => {
  const tempArr = [];
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      const element = params[key];
      if (element !== "" && element != null && element != undefined) {
        tempArr.push(key + "=" + element);
      }
    }
  }
  return tempArr.join("&");
};

const token = authHeader();
// const API_URL = "http://localhost:5362/api";
const API_URL = "http://103.189.173.7:5362/api";

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, params = {}, config = {}) {
  const queryString = buildQueryParams(params);
  const fullUrl = queryString ? `${url}?${queryString}` : url;
  return await axiosApi
    .get(fullUrl, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
